/* OSITOS — Add-to-cart fanfare (DOPAMINE MAX + Candy Sticker popup)
   - 48-emoji rainbow burst from the clicked button
   - Product image arcs to the cart icon
   - Cart icon wobble
   - Tilted candy-sticker popup top-right: product thumb + name + "Ir al carrito" CTA
   - Globally intercepts /cart/add form submits AND [data-osi-quick-add] clicks so no redirect
   - Provides .osi-quick-add button styles for the quick-add snippet
   - Pure CSS animations (transform + opacity), no deps
   - Respects prefers-reduced-motion
*/
(function () {
  if (window.__osiCartFx) return;
  window.__osiCartFx = true;

  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var EMOJIS = [
    '🎉','🎊','✨','⭐','💖','❤️','💛','🧡',
    '💜','🌈','🦄','🍭','🍬','🍰','🧁','🍩',
    '🍒','🍓','🍇','🍑','🍦','🎀','🌸','💎',
    '🍸','🍹','🎈','⚡','🌟','💗','💙','💚'
  ];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function injectStyles() {
    if (document.getElementById('osi-fx-styles')) return;
    var s = document.createElement('style');
    s.id = 'osi-fx-styles';
    s.textContent = [
      '#osi-fx-layer{position:fixed;inset:0;pointer-events:none;z-index:99999;overflow:hidden;contain:strict}',
      '.osi-fx-particle{position:absolute;left:0;top:0;width:var(--size,28px);height:var(--size,28px);line-height:1;text-align:center;font-size:var(--size,28px);will-change:transform,opacity;opacity:0;transform:translate3d(var(--x),var(--y),0) scale(.2) rotate(0deg);animation:osiBurst var(--dur,1200ms) cubic-bezier(.22,.65,.34,1) var(--delay,0ms) forwards;filter:drop-shadow(0 4px 10px rgba(61,8,27,.22));user-select:none;-webkit-user-select:none}',
      '@keyframes osiBurst{0%{opacity:0;transform:translate3d(var(--x),var(--y),0) scale(.2) rotate(0deg)}10%{opacity:1;transform:translate3d(var(--x),var(--y),0) scale(1.15) rotate(calc(var(--rot) * .15))}55%{opacity:1;transform:translate3d(calc(var(--x) + var(--dx)),calc(var(--y) + var(--dy)),0) scale(1) rotate(var(--rot))}100%{opacity:0;transform:translate3d(calc(var(--x) + var(--dx) * 1.25),calc(var(--y) + var(--dy) + 220px),0) scale(.4) rotate(calc(var(--rot) * 1.8))}}',
      '.osi-fx-fly{position:absolute;left:0;top:0;width:var(--size);height:var(--size);transform:translate3d(calc(var(--sx) - var(--size)/2),calc(var(--sy) - var(--size)/2),0);will-change:transform,opacity;border-radius:14px;overflow:hidden;background:#FFD6ED;box-shadow:0 10px 28px rgba(61,8,27,.28);animation:osiFly 880ms cubic-bezier(.45,.05,.55,1) forwards}',
      '.osi-fx-fly img{width:100%;height:100%;object-fit:cover;display:block}',
      '@keyframes osiFly{0%{transform:translate3d(calc(var(--sx) - var(--size)/2),calc(var(--sy) - var(--size)/2),0) scale(1);opacity:1;border-radius:14px}45%{transform:translate3d(calc(var(--mx) - var(--size)/2),calc(var(--my) - var(--size)/2),0) scale(.7);opacity:1;border-radius:50%}85%{transform:translate3d(calc(var(--ex) - var(--size)/2),calc(var(--ey) - var(--size)/2),0) scale(.18);opacity:.9;border-radius:50%}100%{transform:translate3d(calc(var(--ex) - var(--size)/2),calc(var(--ey) - var(--size)/2),0) scale(.04);opacity:0;border-radius:50%}}',
      '.osi-fx-cart-pop{animation:osiCartPop 600ms cubic-bezier(.3,1.7,.45,1) forwards;transform-origin:center}',
      '@keyframes osiCartPop{0%{transform:scale(1) rotate(0)}24%{transform:scale(1.38) rotate(-9deg)}48%{transform:scale(.82) rotate(7deg)}72%{transform:scale(1.14) rotate(-4deg)}100%{transform:scale(1) rotate(0)}}',
      '.osi-fx-pop{position:fixed;top:calc(86px + env(safe-area-inset-top));right:22px;width:min(340px,calc(100vw - 28px));background:#FFD6ED;color:#3D081B;border:3px solid #3D081B;border-radius:22px;padding:14px 16px 16px;box-shadow:8px 10px 0 rgba(61,8,27,.92),0 22px 44px rgba(61,8,27,.22);transform:translateX(140%) rotate(-10deg) scale(.92);opacity:0;transition:transform 560ms cubic-bezier(.2,1.55,.3,1),opacity 280ms ease;z-index:100001;font-family:"Nunito",sans-serif;pointer-events:auto}',
      '.osi-fx-pop--show{transform:translateX(0) rotate(-2.5deg) scale(1);opacity:1}',
      '.osi-fx-pop--hide{transform:translateX(160%) rotate(-12deg) scale(.9);opacity:0}',
      '.osi-fx-pop__sparkle{position:absolute;top:-14px;left:-12px;font-size:28px;line-height:1;transform:rotate(-15deg);animation:osiSparkle 1.6s ease-in-out infinite;filter:drop-shadow(0 2px 4px rgba(61,8,27,.3))}',
      '@keyframes osiSparkle{0%,100%{transform:rotate(-15deg) scale(1)}50%{transform:rotate(8deg) scale(1.15)}}',
      '.osi-fx-pop__close{position:absolute;top:6px;right:10px;width:28px;height:28px;background:transparent;border:none;color:#3D081B;font-size:22px;line-height:1;cursor:pointer;padding:0;font-family:inherit;font-weight:900;opacity:.7;transition:opacity .15s ease,transform .15s ease}',
      '.osi-fx-pop__close:hover{opacity:1;transform:rotate(90deg)}',
      '.osi-fx-pop__row{display:flex;gap:14px;align-items:center;padding-right:28px}',
      '.osi-fx-pop__img{width:64px;height:64px;flex:0 0 64px;border-radius:50%;border:3px solid #3D081B;overflow:hidden;background:#fff;box-shadow:4px 5px 0 rgba(61,8,27,.9);transform:rotate(4deg);position:relative}',
      '.osi-fx-pop__img--placeholder{display:grid;place-items:center;font-size:30px;color:#3D081B}',
      '.osi-fx-pop__img img{width:100%;height:100%;object-fit:cover;display:block}',
      '.osi-fx-pop__body{min-width:0;flex:1}',
      '.osi-fx-pop__title{font-family:"Bebas Neue",sans-serif;font-size:24px;letter-spacing:.06em;line-height:1;margin:0 0 4px;text-transform:uppercase;color:#3D081B}',
      '.osi-fx-pop__name{font-family:"Nunito",sans-serif;font-weight:700;font-size:13px;line-height:1.3;color:#3D081B;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.osi-fx-pop__cta{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:14px;background:#3D081B;color:#FFD6ED;text-decoration:none;font-family:"Bebas Neue",sans-serif;font-size:18px;letter-spacing:.1em;padding:13px 18px;border-radius:999px;text-transform:uppercase;border:2px solid #3D081B;transition:transform .18s ease,background .18s ease,color .18s ease}',
      '.osi-fx-pop__cta:hover,.osi-fx-pop__cta:focus-visible{background:#FFD6ED;color:#3D081B;transform:scale(1.04)}',
      '.osi-fx-pop__cta:focus-visible{outline:3px solid #3D081B;outline-offset:3px}',
      '.osi-fx-pop__arrow{display:inline-block;transition:transform .18s ease}',
      '.osi-fx-pop__cta:hover .osi-fx-pop__arrow{transform:translateX(5px)}',
      '@media (max-width:540px){.osi-fx-pop{top:calc(14px + env(safe-area-inset-top));right:10px;left:10px;width:auto;padding:12px 12px 14px;transform:translateY(-140%) rotate(-6deg) scale(.95)}.osi-fx-pop--show{transform:translateY(0) rotate(-1.5deg) scale(1)}.osi-fx-pop--hide{transform:translateY(-160%) rotate(-8deg) scale(.9)}.osi-fx-pop__img{width:54px;height:54px;flex:0 0 54px}.osi-fx-pop__title{font-size:20px}.osi-fx-pop__cta{font-size:16px;padding:11px 16px}}',
      // ---- Quick-add button (used by snippets/osi-quick-add.liquid) ----
      '.osi-quick-add{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:14px 28px;border-radius:999px;font-family:"Bebas Neue",sans-serif;font-size:18px;letter-spacing:.1em;text-transform:uppercase;text-decoration:none;cursor:pointer;border:2px solid #3D081B;background:#3D081B;color:#FFD6ED;box-shadow:4px 6px 0 rgba(61,8,27,.92);transition:transform .15s ease,background .18s ease,color .18s ease,box-shadow .15s ease;line-height:1}',
      '.osi-quick-add:hover,.osi-quick-add:focus-visible{background:#FFD6ED;color:#3D081B;transform:translate(-2px,-2px);box-shadow:6px 8px 0 rgba(61,8,27,.92)}',
      '.osi-quick-add:active{transform:translate(2px,3px);box-shadow:1px 2px 0 rgba(61,8,27,.92)}',
      '.osi-quick-add:focus-visible{outline:3px solid #3D081B;outline-offset:3px}',
      '.osi-quick-add[disabled]{opacity:.45;cursor:not-allowed;pointer-events:none}',
      '.osi-quick-add--ghost{background:transparent;color:#3D081B}',
      '.osi-quick-add--ghost:hover,.osi-quick-add--ghost:focus-visible{background:#3D081B;color:#FFD6ED}',
      '.osi-quick-add--mini{padding:10px 18px;font-size:14px;box-shadow:3px 4px 0 rgba(61,8,27,.92)}',
      '.osi-quick-add--mini:hover,.osi-quick-add--mini:focus-visible{box-shadow:5px 6px 0 rgba(61,8,27,.92)}',
      '.osi-quick-add__sparkle{display:inline-block;font-size:16px;line-height:1}',
      '@media (prefers-reduced-motion: reduce){.osi-fx-particle,.osi-fx-fly,.osi-fx-cart-pop,.osi-fx-pop__sparkle{animation:none!important}.osi-fx-particle,.osi-fx-fly{opacity:0!important}.osi-fx-pop{transition:opacity 200ms ease!important;transform:none!important}.osi-fx-pop--show{transform:none!important}.osi-quick-add{transition:background .18s ease,color .18s ease!important}.osi-quick-add:hover,.osi-quick-add:active{transform:none!important}}'
    ].join('');
    document.head.appendChild(s);
  }

  function ensureLayer() {
    var l = document.getElementById('osi-fx-layer');
    if (l) return l;
    l = document.createElement('div');
    l.id = 'osi-fx-layer';
    l.setAttribute('aria-hidden', 'true');
    document.body.appendChild(l);
    return l;
  }

  function findCartIcon() {
    return document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href$="/cart"]');
  }

  function rectCenter(el) {
    var r = el.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2, w: r.width, h: r.height };
  }

  function spawnBurst(originX, originY) {
    if (REDUCED) return;
    var layer = ensureLayer();
    var COUNT = 48;
    var frag = document.createDocumentFragment();
    var pool = EMOJIS.slice();
    for (var k = pool.length - 1; k > 0; k--) {
      var j = (Math.random() * (k + 1)) | 0;
      var tmp = pool[k]; pool[k] = pool[j]; pool[j] = tmp;
    }
    for (var i = 0; i < COUNT; i++) {
      var el = document.createElement('span');
      el.className = 'osi-fx-particle';
      var angle = -Math.PI / 2 + (Math.random() - 0.5) * (Math.PI * 0.9);
      var dist  = 80 + Math.random() * 220;
      var dx = Math.cos(angle) * dist;
      var dy = Math.sin(angle) * dist;
      var rot = (Math.random() * 1000 - 500) | 0;
      var size = 22 + ((Math.random() * 24) | 0);
      el.style.setProperty('--x', originX + 'px');
      el.style.setProperty('--y', originY + 'px');
      el.style.setProperty('--dx', dx.toFixed(1) + 'px');
      el.style.setProperty('--dy', dy.toFixed(1) + 'px');
      el.style.setProperty('--rot', rot + 'deg');
      el.style.setProperty('--size', size + 'px');
      el.style.setProperty('--delay', ((i * 7) | 0) + 'ms');
      el.style.setProperty('--dur', (1100 + ((Math.random() * 600) | 0)) + 'ms');
      el.textContent = pool[i % pool.length];
      el.addEventListener('animationend', removeSelf, { once: true });
      frag.appendChild(el);
    }
    layer.appendChild(frag);
  }

  function spawnFlyFromImg(productImg) {
    if (REDUCED || !productImg) return;
    var cart = findCartIcon();
    if (!cart) return;
    var s = rectCenter(productImg);
    var e = rectCenter(cart);
    spawnFlyCore(s.x, s.y, Math.max(48, Math.min(120, s.w * 0.55)), productImg.currentSrc || productImg.src, e);
  }

  function spawnFlyFromPoint(originX, originY, size, imgSrc) {
    if (REDUCED || !imgSrc) return;
    var cart = findCartIcon();
    if (!cart) return;
    spawnFlyCore(originX, originY, size, imgSrc, rectCenter(cart));
  }

  function spawnFlyCore(sx, sy, size, src, e) {
    var mx = (sx + e.x) / 2 + ((e.x - sx) * 0.06);
    var my = Math.min(sy, e.y) - 90;
    var fly = document.createElement('span');
    fly.className = 'osi-fx-fly';
    fly.style.setProperty('--sx', sx + 'px');
    fly.style.setProperty('--sy', sy + 'px');
    fly.style.setProperty('--mx', mx + 'px');
    fly.style.setProperty('--my', my + 'px');
    fly.style.setProperty('--ex', e.x + 'px');
    fly.style.setProperty('--ey', e.y + 'px');
    fly.style.setProperty('--size', size + 'px');
    var img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.decoding = 'async';
    fly.appendChild(img);
    fly.addEventListener('animationend', removeSelf, { once: true });
    ensureLayer().appendChild(fly);
  }

  function bounceCart() {
    if (REDUCED) return;
    var cart = findCartIcon();
    if (!cart) return;
    cart.classList.remove('osi-fx-cart-pop');
    void cart.offsetWidth;
    cart.classList.add('osi-fx-cart-pop');
    cart.addEventListener('animationend', function () {
      cart.classList.remove('osi-fx-cart-pop');
    }, { once: true });
  }

  // ---------- Candy Sticker popup ----------
  var popState = { el: null, dismissTimer: null };

  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  function buildPopup(name, imgSrc) {
    var el = document.createElement('div');
    el.className = 'osi-fx-pop';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    var sparkle = document.createElement('span');
    sparkle.className = 'osi-fx-pop__sparkle';
    sparkle.setAttribute('aria-hidden', 'true');
    sparkle.textContent = '✨';
    el.appendChild(sparkle);

    var close = document.createElement('button');
    close.className = 'osi-fx-pop__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Cerrar');
    close.textContent = '✕';
    close.addEventListener('click', dismissPopup);
    el.appendChild(close);

    var row = document.createElement('div');
    row.className = 'osi-fx-pop__row';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'osi-fx-pop__img';
    if (imgSrc) {
      var img = document.createElement('img');
      img.src = imgSrc; img.alt = ''; img.decoding = 'async';
      imgWrap.appendChild(img);
    } else {
      imgWrap.classList.add('osi-fx-pop__img--placeholder');
      imgWrap.textContent = '🛍️';
    }
    row.appendChild(imgWrap);

    var body = document.createElement('div');
    body.className = 'osi-fx-pop__body';
    var title = document.createElement('div');
    title.className = 'osi-fx-pop__title';
    title.textContent = '¡Añadido al carrito!';
    body.appendChild(title);
    var nm = document.createElement('div');
    nm.className = 'osi-fx-pop__name';
    nm.textContent = name || '';
    body.appendChild(nm);
    row.appendChild(body);
    el.appendChild(row);

    var cta = document.createElement('a');
    cta.className = 'osi-fx-pop__cta';
    cta.href = cartUrl();
    cta.innerHTML = 'Ir al carrito <span class="osi-fx-pop__arrow" aria-hidden="true">→</span>';
    el.appendChild(cta);

    el.addEventListener('mouseenter', clearDismissTimer);
    el.addEventListener('mouseleave', scheduleDismiss);
    el.addEventListener('focusin', clearDismissTimer);
    el.addEventListener('focusout', scheduleDismiss);

    return el;
  }

  function clearDismissTimer() {
    if (popState.dismissTimer) { clearTimeout(popState.dismissTimer); popState.dismissTimer = null; }
  }
  function scheduleDismiss(delay) {
    clearDismissTimer();
    popState.dismissTimer = setTimeout(dismissPopup, typeof delay === 'number' ? delay : 5000);
  }
  function dismissPopup() {
    var el = popState.el;
    if (!el) return;
    clearDismissTimer();
    el.classList.remove('osi-fx-pop--show');
    el.classList.add('osi-fx-pop--hide');
    var done = function () { if (el.parentNode) el.parentNode.removeChild(el); if (popState.el === el) popState.el = null; };
    el.addEventListener('transitionend', done, { once: true });
    setTimeout(done, 700);
  }
  function showPopup(name, imgSrc) {
    if (popState.el && popState.el.parentNode) {
      var existing = popState.el;
      var newEl = buildPopup(name, imgSrc);
      existing.parentNode.replaceChild(newEl, existing);
      popState.el = newEl;
      newEl.classList.remove('osi-fx-pop--show');
      void newEl.offsetWidth;
      requestAnimationFrame(function () { newEl.classList.add('osi-fx-pop--show'); });
      scheduleDismiss();
      return;
    }
    var el = buildPopup(name, imgSrc);
    popState.el = el;
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('osi-fx-pop--show'); });
    });
    scheduleDismiss();
  }
  function updatePopupName(name) {
    if (!popState.el || !name) return;
    var nm = popState.el.querySelector('.osi-fx-pop__name');
    if (nm && nm.textContent !== name) nm.textContent = name;
  }
  function updatePopupImage(url) {
    if (!popState.el || !url) return;
    var wrap = popState.el.querySelector('.osi-fx-pop__img');
    if (!wrap) return;
    var existing = wrap.querySelector('img');
    if (existing) { if (existing.src !== url) existing.src = url; }
    else {
      wrap.classList.remove('osi-fx-pop__img--placeholder');
      wrap.textContent = '';
      var img = document.createElement('img');
      img.src = url; img.alt = ''; img.decoding = 'async';
      wrap.appendChild(img);
    }
  }

  function removeSelf(e) { e.currentTarget.remove(); }

  function nearestProductImage(btn) {
    var card = btn.closest('.card-wrapper, .card-product, .product-card, product-card, .grid__item, li.grid__item, li.card, article.card');
    if (card) {
      var cimg = card.querySelector('.card__media img, .media img, picture img, img');
      if (cimg) return cimg;
    }
    var product = btn.closest('.product, .product-template, .shopify-section--main-product, [data-section-type="product"], main');
    if (product) {
      var pimg = product.querySelector(
        '.product__media-item.is-active img, ' +
        '.product__media-item:not([hidden]):not(.is-hidden) img, ' +
        '.product__media-list li:not([hidden]) img, ' +
        '.product__media img, ' +
        '[data-media-type] img, ' +
        'media-gallery img, ' +
        '.media img, ' +
        'picture img'
      );
      if (pimg) return pimg;
    }
    var form = btn.closest('form');
    if (form) { var fimg = form.querySelector('img'); if (fimg) return fimg; }
    return null;
  }

  function nearestProductTitle(btn) {
    var scope = btn.closest('.card-wrapper, .card, .product-card, product-card, [data-product-id], li, article');
    if (scope) {
      var t = scope.querySelector('[data-product-title], .card__heading a, .card__heading, .card-information__text, .product-card__title, h2 a, h3 a, h2, h3');
      if (t && t.textContent) return t.textContent.trim().slice(0, 80);
    }
    var pdp = document.querySelector('.product__info-wrapper .product__title, .product__title h1, .product__title, h1.product-single__title, main h1');
    if (pdp && pdp.textContent) return pdp.textContent.trim().slice(0, 80);
    return '';
  }

  function isAddBtn(el) {
    if (!el || !el.closest) return null;
    return el.closest(
      'product-form button[type="submit"], ' +
      'form[action*="/cart/add"] button[type="submit"], ' +
      'form[action$="/cart/add"] button[type="submit"]'
    );
  }

  // ---------- Shared AJAX add ----------
  function ajaxAdd(formData, optimisticImg) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw json;
          return json;
        });
      })
      .then(function (data) {
        if (data && data.sections && data.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            var newBubble = parsed.querySelector('#cart-icon-bubble');
            if (newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
        }
        var item = (data && data.items && data.items[0]) || data || {};
        if (item.product_title) updatePopupName(item.product_title);
        var imgUrl = item.image || (item.featured_image && (item.featured_image.url || item.featured_image)) || null;
        if (imgUrl) updatePopupImage(imgUrl);
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'osi-cart-fx',
                cartData: cart,
                variantId: item.variant_id || item.id
              });
            })
            .catch(function () {});
        }
      })
      .catch(function (err) {
        dismissPopup();
        console.warn('[osi-cart-fx] add failed:', err && err.description || err);
      });
  }

  function buildAddFormData(variantId, quantity) {
    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', String(quantity));
    fd.append('sections', 'cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    return fd;
  }

  // ---------- Click handler ----------
  function onClick(e) {
    // Highest priority: quick-add link/button anywhere on the page
    var quick = e.target.closest('[data-osi-quick-add]');
    if (quick) {
      if (quick.getAttribute('aria-disabled') === 'true' || quick.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      handleQuickAdd(quick);
      return;
    }

    // Regular add-to-cart button inside a form (Dawn or generic)
    var btn = isAddBtn(e.target);
    if (!btn) return;
    if (btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;
    var br = btn.getBoundingClientRect();
    var ox = br.left + br.width / 2;
    var oy = br.top + br.height / 2;
    var img = nearestProductImage(btn);
    var imgSrc = img ? (img.currentSrc || img.src) : null;
    var title = nearestProductTitle(btn);
    spawnBurst(ox, oy);
    spawnFlyFromImg(img);
    bounceCart();
    showPopup(title, imgSrc);
  }

  function handleQuickAdd(el) {
    var variantId = el.getAttribute('data-osi-quick-add');
    if (!variantId) return;
    var quantity = parseInt(el.getAttribute('data-osi-quantity') || '1', 10) || 1;
    var title = el.getAttribute('data-osi-product-title') || '';
    var imgSrc = el.getAttribute('data-osi-product-image') || null;

    var br = el.getBoundingClientRect();
    var ox = br.left + br.width / 2;
    var oy = br.top + br.height / 2;

    spawnBurst(ox, oy);
    if (imgSrc) spawnFlyFromPoint(ox, oy, 80, imgSrc);
    bounceCart();
    showPopup(title, imgSrc);

    ajaxAdd(buildAddFormData(variantId, quantity));
  }

  // ---------- Intercept regular /cart/add form submits ----------
  function onSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || form.action || '';
    if (action.indexOf('/cart/add') < 0) return;
    if (form.closest('product-form')) return; // Dawn handles AJAX itself
    e.preventDefault();
    e.stopImmediatePropagation();
    var fd = new FormData(form);
    fd.append('sections', 'cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    ajaxAdd(fd);
  }

  function onCartUpdate(payload) {
    if (!payload) return;
    if (payload.source === 'cart-items') return;
    var cart = payload.cartData;
    if (!cart || !cart.items || !cart.items.length) return;
    var vid = payload.variantId;
    var match = vid && cart.items.find(function (it) { return String(it.variant_id) === String(vid); });
    var item = match || cart.items[cart.items.length - 1];
    if (!item) return;
    if (item.product_title) updatePopupName(item.product_title);
    var imgUrl = item.image || (item.featured_image && (item.featured_image.url || item.featured_image)) || null;
    if (imgUrl) updatePopupImage(imgUrl);
  }

  ready(function () {
    injectStyles();
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    } else {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          clearInterval(iv);
          window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
        } else if (tries > 20) {
          clearInterval(iv);
        }
      }, 150);
    }
  });
})();
